import React, { useState, useEffect } from "react";
import SC from "../style";
import theme from "@theme";
import { Checkbox } from "@mui/material";
import { apiGet } from "api/callApi";
import { ProjectDropdown } from "@components/";

const OccupantList = (props) => {
  const {
    onClose,
    occupantData = [],
    checkedOccupants = [],
    setCheckedOccupants = () => {},
  } = props;
  const [searchTerm, setSearchTerm] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");
  const [selectedProject, setSelectedProject] = useState("");

  // Sort toggle
  const handleSort = () => {
    setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
  };

  // Individual checkbox toggle
  const handleCheckboxChange = (occupantId) => {
    setCheckedOccupants((prev) =>
      prev.includes(occupantId)
        ? prev.filter((pid) => pid !== occupantId)
        : [...prev, occupantId]
    );
  };


  // Select/Deselect all
  const handleSelectAll = () => {
    if (areAllSelected) {
      setCheckedOccupants([]);
    } else {
      const allIds = filteredOccupants.map((item) => item.occupantId);
      setCheckedOccupants(allIds);
    }
  };

  // Sorting logic
  const sortedRoles = [...occupantData].sort((a, b) => {
    const roleA = a.occupantName.toLowerCase();
    const roleB = b.occupantName.toLowerCase();
    return sortDirection === "asc"
      ? roleA.localeCompare(roleB)
      : roleB.localeCompare(roleA);
  });

  const filteredOccupants = sortedRoles.filter((item) => {
    const normalizedSearch = searchTerm.replace(/\s/g, "").toLowerCase();

    const matchesOccupant = item.occupantName
      ?.replace(/\s/g, "")
      .toLowerCase()
      .includes(normalizedSearch);

    const matchesProperty = item.propertyName
      ?.replace(/\s/g, "")
      .toLowerCase()
      .includes(normalizedSearch);

    const matchesProject =
      selectedProject && selectedProject !== "all"
        ? item.projectId == selectedProject
        : true;

    return (matchesOccupant || matchesProperty) && matchesProject;
  });

  const areAllSelected =
    filteredOccupants.length > 0 &&
    filteredOccupants.every((item) =>
      checkedOccupants.includes(item.occupantId)
    );

  return (
    <>
      <SC.TitleConatiner>
        <SC.Title> Select Occupants to Apply Changes</SC.Title>
        <SC.Description>
          Choose the occupants where you want to reflect the updated folder
          template. Only selected occupants will inherit the new structure.
        </SC.Description>
      </SC.TitleConatiner>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "0px 20px 10px 20px",
        }}
      >
        <SC.InputContiner>
          <SC.SearchIcon />
          <SC.InputStyle
            placeholder="Search occupant"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </SC.InputContiner>

        <ProjectDropdown
          showAllProjectOption={true}
          onChange={(value) => setSelectedProject(value)}
        />
      </div>
      <SC.Container>
        <SC.Table>
          <SC.Thead>
            <SC.Trheader>
              <SC.Th> S. No. </SC.Th>
              <SC.ThRole>
                Occupant List
                <SC.SwapVertIcon onClick={handleSort} />
              </SC.ThRole>
              <SC.Th>Project Name </SC.Th>
              <SC.Th>
                <Checkbox
                  checked={areAllSelected}
                  onChange={handleSelectAll}
                  sx={{
                    "&.Mui-checked": {
                      color: theme.colors.themeColor,
                    },
                  }}
                  size="small"
                />
              </SC.Th>
            </SC.Trheader>
          </SC.Thead>
          <SC.Tbody>
            {filteredOccupants.length === 0 ? (
              <SC.Tr>
                <SC.Td
                  colSpan={4}
                  style={{ textAlign: "center", padding: "16px" }}
                >
                  No data
                </SC.Td>
              </SC.Tr>
            ) : (
              filteredOccupants.map((item, index) => (
                <SC.Tr key={item.id}>
                  <SC.Td>{index + 1}</SC.Td>
                  <SC.TdRole>{item.occupantName}</SC.TdRole>
                  <SC.Td>{item.propertyName}</SC.Td>
                  <SC.Td>
                    <Checkbox
                      checked={checkedOccupants.includes(item.occupantId)}
                      onChange={() => handleCheckboxChange(item.occupantId)}
                      sx={{
                        "&.Mui-checked": {
                          color: theme.colors.themeColor,
                        },
                      }}
                      size="small"
                    />
                  </SC.Td>
                </SC.Tr>
              ))
            )}
          </SC.Tbody>
        </SC.Table>
      </SC.Container>
    </>
  );
};

export default OccupantList;
